import styles from './dropdown.module.less';

const Dropdown = ({ children, labelText, id, name, className, ...expandingProps }) => {
    const dropdownId = id || 'dropdown';
    const dropdownName = name || 'type';
    return (
        <>
            {labelText && (
                <label htmlFor={dropdownId} className={styles.dropdownLabel}>
                    {labelText}
                </label>
            )}
            <select
                id={dropdownId}
                name={dropdownName}
                className={[styles.dropdown, className].join(' ')}
                {...expandingProps}
            >
                {children}
            </select>
        </>
    );
};

export default Dropdown;
